import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  token: undefined,
  type: 'Bearer',
  test: {
    openResultDialog: false,
    resultTest: null,
    fullName: '',
    tabs: [],
  },
  user: {},
  cart: [],
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    toggleAuth(state, action) {
      if (action.payload !== undefined) {
        state.token = action.payload.token;
        state.user = action.payload;
      } else {
        state.token = undefined;
      }
    },
    setUser(state, action) {
      const payload = action.payload;
      state.user = {
        ...state.user,
        ...payload,
      };
    },
    setResultTest(state, action) {
      const payload = action.payload;
      state.test = {
        ...state.test,
        ...payload,
      };
    },
    clearCart(state) {
      state.cart = [];
    },
    setCart(state, action) {
      const payload = action.payload;
      state.cart = [...state.cart, payload];
    },
    deleteCart(state, action) {
      const productId = action.payload;
      state.cart = state.cart.filter((i) => i.productId !== productId) || [];
    },
    updateCart(state, action) {
      const { productId, quantity } = action.payload;
      state.cart = state.cart.map((item) =>
        item.productId === productId ? { ...item, quantity } : item,
      );
    },
  },
});

export default userSlice;
export const { toggleAuth, setUser, setResultTest, setCart, deleteCart, updateCart, clearCart } =
  userSlice.actions;
